<template>
<div>
    <messaging 
      :display="message.display" 
      :bottom="message.bottom" 
      :top="message.top" 
      :text="message.text" 
      :timeout="message.timeout" 
      v-on:closed="message.display=false" />
      
    <v-app-bar 
      app 
      elevate-on-scroll
      height="80"
      style="padding-top:4px; z-index:200;">
      <!-- shrink-on-scroll
      fade-img-on-scroll
      src="https://picsum.photos/1920/1080?random" -->
      
        <v-row v-if="$store.getters.user && $store.getters.user.assumed_user_by!==0" align="center" justify="space-around"
            style="height: auto; background-color:red; color: #ffffff;position:absolute; top:-3px; width:100%;"
        >
            <div>You are viewing the account of <{{$store.getters.user.email}}></div>
            <v-btn class="text-center" outlined small dark depressed  height="20" @click="deproxify()">Back to My Account</v-btn>
        </v-row>
        
        <v-row align='center'>
          <v-btn icon @click="menu=!menu" style="margin-left: 1%;" v-if="acceptCurrentRoute">
            <v-app-bar-nav-icon/>
          </v-btn>

          <v-spacer></v-spacer>

          <div @click="goHome" :class="[$style.logoWrapper, {[$style.logoWrapperMdAndUp]: $vuetify.breakpoint.mdAndUp}]">
            <template v-if="$vuetify.breakpoint.mdAndUp">
              <template v-if="$route.name !== 'admin'">
                <img :src="vivomapLogo" :class="$style.logo"/>
              </template>

              <template v-else>
                <img :src="vivomapAdminLogo" :class="$style.adminLogo"/>
              </template>
            </template>
            <template v-else>
              <img :src="vivomapMobileLogo" :class="$style.logo"/>
            </template>
          </div>

          <v-spacer></v-spacer>

          <template v-if="acceptCurrentRoute">
            <UserDisc v-if="$store.getters.user"/>
            <Button_SignInOut v-else :class="$style.signInital"/> 
          </template>
          <Language style="transform:translateY(10%)" @flashMessage="flashMessage"/>
        </v-row>
    </v-app-bar>

    <MainMenu :menu="menu" v-on:close="closeMenu"/>

</div>  
</template>

<script>
import vivomapLogo from '@/assets/images/logos/vivomap.png';
import vivomapAdminLogo from '@/assets/images/logos/vivomap_admin.png';
import vivomapMobileLogo from '@/assets/images/logos/vivomap_mobile.png';
import MainMenu from '@/components/UI/MainMenu.vue';
import UserDisc from '@/components/UI/UserDisc.vue';
import Button_SignInOut from '@/components/Buttons/SignInOut.vue';
import Language from '@/components/UI/Language.vue';

export default {
    name: 'appBar',
    components: {
        MainMenu,
        UserDisc,
        Button_SignInOut,
        Language
    },
    created: function() {
    },  
    data: function(){
        return {
            mode: null,
            menu: false, 
            acceptCurrentRoute: true,
            message: {
                display: false,
                text: 'sample text',
                timeout: null,
                bottom: false,
                top: true
            }            
        }
    },
    methods: {
        goHome: function(){
          if (this.acceptCurrentRoute) {
            this.$router.push({ path: '/' })
          }
        },
        closeMenu: function(){
            this.menu = false;
        },
        flashMessage: function(msgDetails){
            this.message.text = msgDetails.text;
            this.message.display = true;
            this.message.top = msgDetails.top;
            this.message.bottom = msgDetails.bottom;
            this.message.timeout = msgDetails.timeout;            
        },
        deproxify: function(){
            let self = this;
            let action = 'userAdmin';
            let call = 'assumeUser';
            this.$sendBackgroundRequest({
                action : action,
                call: call,
                user_id: self.$store.getters.user.assumed_user_by
            }).then(function(response){
                self.customCLog('assumeUser',response.data[action][call]);
                self.$store.dispatch('jwt',response.data[action][call].jwt);
                location.reload();
            });
        }
    },
    computed:{
        vivomapLogo: function(){
            return vivomapLogo;
        },
        vivomapAdminLogo: function() {
          return vivomapAdminLogo;
        },
        vivomapMobileLogo: function() {
          return vivomapMobileLogo;
        }
    },
    watch: {
      '$route.name': function(after) {
        if(after === '404' || after === 'notSupport'){
          this.acceptCurrentRoute = false;
        } else {
          this.acceptCurrentRoute = true;
        }
      }
    }
}
</script>

<style module>
.logoWrapper {
  cursor: pointer;  
}

.logoWrapperMdAndUp {
  cursor: pointer;  
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.logo{
  max-height: 90px; 
  margin-top: 0px !important;
}

.adminLogo{
  max-height: 40px; 
  margin-top: 0px !important;
}

.signInital {
  cursor: pointer;
  border-right: 1px solid #eceaea;
  padding-right: 25px;
}

@media only screen and (max-width: 933px) {
  .logo {
    max-width: 100%;
	}
  }

@media only screen and (max-width: 650px) {
  .logoWrapper {
  margin-left:0 !important;
}

.signInital {
  padding-right: 10px;
}
}
</style>